import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DataTypeProvider } from "@devexpress/dx-react-grid";

const SapStatusFormatter = ({ value }) => <TextField value={value == "COD" ? "Código operadora" : value} InputProps={{ disableUnderline: true }} />;

const SapStatusEditor = ({ value, onValueChange, disabled }) => {
  if (disabled) {
    return value ?? "";
  }

  return (
    <Select input={<Input />} value={value} onChange={(event) => onValueChange(event.target.value)} style={{ width: "100%" }}>
      {/* <MenuItem value="CONCLUIDO">CONCLUIDO</MenuItem> */}
      {/* <MenuItem value="CONCLUIDO MANUALMENTE">CONCLUIDO MANUALMENTE</MenuItem> */}
      <MenuItem value="NAO PROCESSAR">NAO PROCESSAR</MenuItem>
      <MenuItem value="CANCELADO">CANCELADO</MenuItem>
    </Select>
  );
};
export const SapStatusTypeProvider = (props) => <DataTypeProvider formatterComponent={SapStatusFormatter} editorComponent={SapStatusEditor} {...props} />;
